import Page from '..';
import logoTools from '../../../images/LOGO_TOOLS_AZUL.png';
import nootbook from '../../../images/NOTETOOLS.png';
import Form from '../../Form';
import SVG from '../../SVG';
import './Home.css';
import { ContainerRight, ImgNotbook, ImgTools, LeftContainer } from './style';
export default function PageHome() {
  return (
    <Page className="page-home">
      <div className="esquerdo">
        <LeftContainer>
          <div className="LeftContainer-margin">
            <ImgTools src={logoTools} />
            <span className="span-login">Login</span>
            <Form.Login />
          </div>
        </LeftContainer>
      </div>
      <div className="direito">
        <ContainerRight>
          <div className="ContainerRight-margin">
            <div className="text-one">Otimize tempo, recursos e dinheiro!</div>
            <div className="text-two">
              Um pacote de ferramentas para facilitar e agilizar as suas
              operações diarias!
            </div>
            <ImgNotbook src={nootbook} />
          </div>
        </ContainerRight>
      </div>
    </Page>
  );
}
